export default {
  history: {
    perPage: 20,
  },
  teamHistory: {
    perPage: 12,
  },
};
